import { Alert } from "components";

export default function Unverified(){
    return(
    <Alert title="Dados migrados do sistema anterior" status="warning">
        Os dados contidos nessa tela foram migrados do sistema anterior, portanto, as informações podem estar desatualizadas ou corrompidas. O sistema (ADM)
        anterior está disponível <b>apenas para consulta</b> em caso de dúvidas sobre pedidos migrados. Qualquer inconsistência, contate o Suporte de T.I.
    </Alert>
    )
}